import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { COMPACT_QUERY } from "../../../utils/hooks/useCompact";

const compact = "@media " + COMPACT_QUERY;

interface ImageModalProps {
  open: boolean;
  images: string[];
  handleClose: () => void;
}

export default function ImageModal({
  open,
  images,
  handleClose,
}: ImageModalProps) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: { sx: { [compact]: { maxHeight: "94vh", m: 2 } } },
      }}
    >
      <DialogTitle>รูปภาพเพิ่มเติม</DialogTitle>
      <DialogContent dividers>
        {images.map((image) => (
          <Box
            key={image}
            component="img"
            src={image}
            sx={{
              width: "80%",
              height: "auto",
              borderRadius: 1,
              display: "flex",
              margin: "24px auto",
              [compact]: { width: "100%", margin: "12px auto" },
            }}
          />
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained">
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
